export const getProfessorGuidance = (state) => state.guidances;
export const getProfessorCoGuidance = (state) => state.coGuidances;
